<!--
  AugerLink.vue
  A link from a chip to the thing it names. The package knows no routes: the app
  registers how a target becomes a URL (see ./registry). With nothing registered
  it renders its content as plain text, so a chip is never a dead link.

  Props:
    - target: What to link to — a record or a tag (AugerLinkTarget). Null renders
      the content with no link.
  Attributes (class, style, @click) fall through to the rendered element.
-->
<template>
  <component :is="links?.component" v-if="to != null && links?.component" :to="to">
    <slot />
  </component>
  <a v-else-if="typeof to === 'string'" :href="to"><slot /></a>
  <span v-else><slot /></span>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { type AugerLinkTarget, getAugerLinks } from "./registry"

const props = defineProps<{ target: AugerLinkTarget | null }>()

const links = computed(() => getAugerLinks())
const to = computed(() => (props.target ? links.value?.resolve(props.target) : null))
</script>
